import React from 'react';
import {
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  Pause as PauseIcon,
  Settings as SettingsIcon,
} from '@mui/icons-material';

export const getCaixaStatusColor = (status: string) => {
  switch (status) {
    case 'ativo':
      return 'success';
    case 'inativo':
      return 'error';
    case 'aguardando_instalacao':
      return 'info';
    case 'manutencao':
      return 'warning';
    default:
      return 'default';
  }
};

export const getCaixaStatusIcon = (status: string) => {
  switch (status) {
    case 'ativo':
      return <CheckCircleIcon color="success" fontSize="small" />;
    case 'inativo':
      return <ErrorIcon color="error" fontSize="small" />;
    case 'aguardando_instalacao':
      return <SettingsIcon color="info" fontSize="small" />;
    case 'manutencao':
      return <PauseIcon color="warning" fontSize="small" />;
    default:
      return <SettingsIcon fontSize="small" />;
  }
};

export const getCaixaStatusLabel = (status: string) => {
  switch (status) {
    case 'ativo':
      return 'Ativo';
    case 'inativo':
      return 'Inativo';
    case 'aguardando_instalacao':
      return 'Aguardando Instalação';
    case 'manutencao':
      return 'Manutenção';
    default:
      return status;
  }
}; 